
//TODO:
import React from 'react';
import {string} from 'prop-types';
import {ProgressIndicator} from '@sabre/spark-react-core';

import {SIZE} from '../../utils/constants.js';

const Loader = ({className = '', size = SIZE.LARGE, message = 'Loading...', type = 'indeterminate'}) => {

    return (
        <div className={`loader-container${className ? ` ${className}` : ''}`}>
            <div className='loader-panel'>
                <div className='loader'>
                    <ProgressIndicator
                        size={size}
                        progressText={message}
                        type={type}
                    />
                </div>
            </div>
        </div>
    );
};

Loader.propTypes = {
    className: string,
    size: string,
    message: string,
    type: string
};

export default Loader;
